import React, { useState, useEffect } from 'react';
import { rescueHtml } from '../Components/Tools.js';
import Gantt from '../Components/GanttComponent';
import Logo from '../Img/Logo_projets&finances.png';

const Page4Echeancier_Operations = (props) => {
    const blue = '#069BD3';
    const green = '#59B44A';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';
    const fontsize = (props.height*12/890);

    const FieldBoxLargeTop = ({label}) => (
        <div style={{padding: 8, backgroundColor: greyChapter, width: '30%', borderTopLeftRadius: 3, borderBottomLeftRadius: 3, textAlign: 'left', display: 'flex', alignItems: 'center'}}>
            <p style={{margin: 0, fontSize: fontsize+2, lineHeight: 1.2}}>{label}</p>
        </div>
    );

    const ValueBoxLargeTop = ({value}) => (
        <div style={{padding: 8, backgroundColor: greyclair, width: '70%', borderTopRightRadius: 3, borderBottomRightRadius: 3, textAlign: 'left', display: 'flex', alignItems: 'center'}}>
            <p style={{textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%', margin: 0, fontSize: fontsize+2, lineHeight: 1.2}}>{value || ''}</p>
        </div>
    );

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white'}}>
            
            {/* Header */}
            <div style={{ display: 'flex', height: '20%' }}>
                <div style={{ flex: 0.6, display: 'flex', marginLeft: 10 }}>
                    {props.logo && (
                        <img style={{ maxHeight: props.height / 8, borderRadius: 5 }} src={props.logo} alt="Logo" />
                    )}
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: blue, fontSize: (fontsize + 10) }}>Échéancier</p>
                </div>

                <div style={{ flex: 0.6, display: 'flex', justifyContent: 'right', marginRight: 25 }}>
                    <p style={{ color: 'grey', fontSize: (fontsize + 4) }}>{props.operation.nom}</p>
                </div>
            </div>

            {/* Contenu - 60% */}
            <div style={{flex: 1, padding: '10px 15px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '10px'}}>
                
                {/* Ligne 1: Étapes programmatiques */}
                <div style={{display: 'flex', height: 70}}>
                    <FieldBoxLargeTop label="Étapes programmatiques" />
                    <ValueBoxLargeTop value={rescueHtml(props.operation.etapes_programmatiques || '')} />
                </div>

                {/* Gantt Chart */}
                <div style={{flex: 1, overflow: 'auto', borderRadius: '4px', backgroundColor: greyclair, padding: '10px'}}>
                    <Gantt user={props.user} id_operation={props.operation.id} operation={props.operation} isBilan={true} modifiable={false}/>
                </div>

            </div>

            {/* Footer - 20% */}
            <div style={{padding: '5px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1}}>
                <div>
                    <p style={{fontSize: fontsize, color: '#666'}}>
                        {props.date}
                    </p>
                </div>
                <p style={{fontSize: fontsize, color: '#8B8B8B'}}>page : {props.pagination} / {props.countPageTotal}</p>
                <div>
                    <img style={{objectFit: 'contain', height: 40, borderRadius: 6}} src={Logo} alt="Logo SF" />
                </div>
            </div>
        </div>
    );
};

export default Page4Echeancier_Operations;
